document.addEventListener('click', function (event) {
    const messageTab = document.getElementById('giftMessage');
    const deliveryTab = document.getElementById('scheduleDelivery');

    // 1. GREETING CARD ADD/REMOVE LOGIC
    const cardAddBtn = event.target.closest('.greetingCardBody .glproGiftWrapAddButton');
    const cardRemoveBtn = event.target.closest('.greetingCardBody .glproGiftWrapRemoveButton');

    if (cardAddBtn) {
        messageTab.classList.add('active-card');
    } 
    if (cardRemoveBtn) {
        messageTab.classList.remove('active-card');
    }

    // 2. NEXT BUTTON VALIDATION
    const nextBtn = event.target.closest('.greetingCardNextButton');
    if (nextBtn) {
        // Find if Message Body is currently visible
        const messageBody = document.querySelector('.giftMessageBody');
        const isMessageVisible = window.getComputedStyle(messageBody).display !== 'none';

        if (isMessageVisible) {
            // Your exact class from the screenshot
            const messageArea = document.querySelector('.glproGiftMessageV2InputField');
            const fromField = document.querySelector('.glproGiftMessageV2FromField');
            const toField = document.querySelector('.glproGiftMessageV2ToField');

            // Check if Message is empty
            if (messageArea && messageArea.value.trim() === "") {
                event.stopImmediatePropagation(); // STOP THE APP FROM MOVING
                event.preventDefault();           // STOP THE DEFAULT ACTION
                
                alert("Please enter your message before proceeding.");
                return false; 
            }
            
            // Optional: 'To' and 'From' koodi validate cheyyaan thiricheyyaam
            if ((fromField && fromField.value.trim() === "") || (toField && toField.value.trim() === "")) {
                event.stopImmediatePropagation();
                alert("Please fill 'From' and 'To' fields.");
                return false;
            }
        } else {
            // Message visible allenkil (Card select cheythillenkil) skip cheythu pookum
            const isCardSelected = document.querySelector('.greetingCardBody .glproGiftWrapRemoveButton');
            if (!isCardSelected) {
                event.stopImmediatePropagation();
                if (deliveryTab) deliveryTab.click();
            }
        }
    }
}, true); // 'true' is critical here to catch the click BEFORE the app does